import { render, staticRenderFns } from "./UserTabBonusCharge.vue?vue&type=template&id=a6769a96"
import script from "./UserTabBonusCharge.vue?vue&type=script&lang=js"
export * from "./UserTabBonusCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports